import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login/login.component';
import { RegisterComponent } from './features/auth/register/register.component';
import { HomeComponent } from './features/dashboard/home/home.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { ProfileComponent } from './features/user/profile/profile.component';
import { ManageProfileComponent } from './features/user/manage-profile/manage-profile.component';
import { CambioContrasenaComponent } from './features/user/cambio-contrasena/cambio-contrasena.component';
import { AssistancesComponent } from './features/dashboard/assistances/assistances.component';
import { AssistanceLayoutComponent } from './layouts/assistance-layout/assistance-layout.component';
import { NuevaContrasenaComponent } from './features/auth/nueva-contrasena/nueva-contrasena.component';
import { CodigoContrasenaComponent } from './features/auth/codigo-contrasena/codigo-contrasena.component';
import { ProfileLayoutComponent } from './layouts/profile-layout/profile-layout.component';
// DEPENDIENTES OCULTOS TEMPORALMENTE
// import { ProfileDependientesComponent } from './features/user/profile-dependientes/profile-dependientes.component';
import { ProfileDireccionesComponent } from './features/user/profile-direcciones/profile-direcciones.component';
import { ProfileRegistrosComponent } from './features/user/profile-registros/profile-registros.component';

import { AddMascotaComponent } from './features/user/add-mascota/add-mascota.component';
import { AddVehiculoComponent } from './features/user/add-vehiculo/add-vehiculo.component';
// import { AddDependienteComponent } from './features/user/add-dependiente/add-dependiente.component';
import { AddDireccionComponent } from './features/user/add-direccion/add-direccion.component';
import { UpdateDireccionComponent } from './features/user/update-direccion/update-direccion.component';
// import { UpdateDependientesComponent } from './features/user/update-dependientes/update-dependientes.component';
import { UpdateRegisterComponent } from './features/user/update-register/update-register.component';
import { ErrorDataComponent } from './features/auth/register/error-data/error-data.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ServicesComponent } from './features/services/components/services/services.component';
import { RequestComponent } from './features/request/components/request/request.component';
import { AmbulanceConfirmedComponent } from './features/dashboard/assistances/ambulance-assistance/ambulance-confirmed/ambulance-confirmed.component';
import { ServiceRequestComponent } from './features/services/components/service-request/service-request.component';
import { ServiceConfirmComponent } from './features/services/components/service-confirm/service-confirm.component';
import { RequestDetailsComponent } from './features/request/components/request-details/request-details.component';
import { VialAssistanceConfirmComponent } from './features/dashboard/assistances/vial-assistance/vial-assistance-confirm/vial-assistance-confirm.component';
import { SegundaOpinionComponent } from './features/dashboard/assistances/segunda-opinion/segunda-opinion.component';
import { SegundaOpinionConfirmadaComponent } from './features/dashboard/assistances/segunda-opinion/segunda-opinion-confirm/segunda-opinion-confirmada.component';
import { AmbulanceInternationalComponent } from './features/dashboard/assistances/ambulance-international/ambulance-international.component';
import { AmbulanceExtranjeroComponent } from './features/dashboard/assistances/ambulance-extranjero/ambulance-extranjero.component';
import { RepatriacionComponent } from './features/dashboard/assistances/repatriacion/repatriacion.component';
import { TrasladoFamiliarComponent } from './features/dashboard/assistances/traslado-familiar/traslado-familiar.component';
import { PagoHotelComponent } from './features/dashboard/assistances/pago-hotel/pago-hotel.component';



import { PrivacyPolicyComponent } from './shared/components/Privacy-policy/privacy-policy.component';
import { TermsComponent } from './shared/components/terms/terms.component';
import { ContactComponent } from './features/auth/contact/contact.component';

import { CodeBanamexComponent } from './features/auth/register/code-banamex/code-banamex.component';
import { FormRegisterBanamexComponent } from './features/auth/register/form-register-banamex/form-register-banamex.component';

import { MedicaTelefonicaConfirmComponent } from './features/dashboard/assistances/medica-telefonica/medica-telefonica-confirm/medica-telefonica-confirm.component';
import { DrVideoComponent } from './features/dashboard/assistances/dr-video/dr-video.component';
import { MedicalCheckupConfirmedComponent } from './features/dashboard/assistances/medical-checkup/medical-checkup-confirmed/medical-checkup-confirmed.component';
import { FaqComponent } from './shared/components/faq/faq.component';
import { BranchsComponent } from './features/benefits/components/benefist/branchs/branchs.component';
import { BenefistInfoComponent } from './features/benefits/components/benefist/benefist-info/benefist-info.component';
import { BenefistComponent } from './features/benefits/components/benefist/benefist.component';
import { BenefitsLayoutComponent } from './layouts/benefits-layout/benefits-layout.component';


export const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: '', component: LoginComponent },
      { path: 'registro', component: RegisterComponent },
      { path: 'error-data', component: ErrorDataComponent },
      { path: 'nuevacontrasena', component: NuevaContrasenaComponent },
      { path: 'codigocontrasena', component: CodigoContrasenaComponent },
      { path: 'privacy', component: PrivacyPolicyComponent },
      { path: 'terms', component: TermsComponent },
      { path: 'faq', component: FaqComponent },
      { path: 'contact', component: ContactComponent },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    title: 'Inicio | iké now',
    canActivate: [AuthGuard],
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'services', component: ServicesComponent },
      { path: 'solicitudes', component: RequestComponent },
      { path: 'solicitud/detalle/:expediente', component: RequestDetailsComponent},
      { path: 'perfil', component: ProfileComponent },            
      { path: 'service/segunda-opinion-confirmada', component: SegundaOpinionConfirmadaComponent },
      { path: 'service/medica-telefonica-confirmada', component: MedicaTelefonicaConfirmComponent },
      { path: 'solicitud/medical-checkup', component: MedicalCheckupConfirmedComponent },
      { path: 'service/ambulancia-internacional', component: ServiceRequestComponent },
      { path: 'service/ambulancia-extranjero', component: ServiceRequestComponent },
      { path: 'service/repatriacion', component: ServiceRequestComponent },
      { path: 'service/traslado-familiar', component: ServiceRequestComponent },
      { path: 'service/pago-hotel', component: ServiceRequestComponent },
      { path: 'service/dr-video', component: DrVideoComponent },



      { path: 'service/:nombre', component: ServiceRequestComponent },
      { path: 'service/confirm/:serviceType', component: ServiceConfirmComponent },
      { path: 'service/confirm/form/vial', component: VialAssistanceConfirmComponent }
    ],
  },
  {
    path: '',
    component: AssistanceLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'assistance', component: AssistancesComponent },
      { path: 'ambulance', component: ServiceRequestComponent },
      { path: 'confirm', component: AmbulanceConfirmedComponent },
    ],
  },
  {
    path: '',
    component: ProfileLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'headerprofile', component: ProfileComponent },
      { path: 'administrar-perfil', component: ManageProfileComponent },
      { path: 'gestion-perfil', component: ManageProfileComponent },
      { path: 'cambio-contrasena', component: CambioContrasenaComponent },
      // { path: 'profile-dependientes', component: ProfileDependientesComponent },
      { path: 'profile-direcciones', component: ProfileDireccionesComponent },
      { path: 'profile-registros', component: ProfileRegistrosComponent },
      { path: 'add-mascota', component: AddMascotaComponent },
      { path: 'add-vehiculo', component: AddVehiculoComponent },
      // { path: 'add-dependiente', component: AddDependienteComponent },
      { path: 'add-direccion', component: AddDireccionComponent },
      { path: 'update-direccion', component: UpdateDireccionComponent },
      // { path: 'update-dependientes', component: UpdateDependientesComponent },
      { path: 'update-register', component: UpdateRegisterComponent }
    ],
  },
  {
    path: '',
    component: BenefitsLayoutComponent,
    children: [
      { path: 'beneficios', component: BenefistComponent },
      { path: 'benefitsInfo', component: BenefistInfoComponent },
      { path: 'branchs', component: BranchsComponent },
    ],
  },

  {
    path: 'code-banamex',
    component: CodeBanamexComponent
  },
  {
    path: 'form-register-banamex', 
    component: FormRegisterBanamexComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];
